import React from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useChangeEmployeeEmailMutation } from '../../__generated__/graphql';
import { routes } from '../../routes';
import ServerError from '../../../../components/ServerError';
import { useAuth } from '../../../../context/AuthContext';
import { root as dashboardRoot } from '../../../dashboard/routes';
import { useEffect, useRef } from 'react';

type RouteParams = {
  organizationId: string;
};

const Loading: React.FC<React.PropsWithChildren<unknown>> = () => (
  <div className="text-center">
    <div className="spinner-border" role="status" />
  </div>
);

const ChangeEmail: React.FC<React.PropsWithChildren<unknown>> = () => {
  const history = useHistory();
  const { organizationId } = useParams<RouteParams>();
  const queryString = new URLSearchParams(useLocation().search);
  const token = queryString.get('token') || 'invalidToken';
  const [changeEmployeeEmail, { data, loading, error }] =
    useChangeEmployeeEmailMutation({});
  // The change-email token is single-use. Guard against StrictMode's
  // double-invoke so the mutation runs exactly once.
  const hasSubmitted = useRef(false);

  useEffect(() => {
    if (hasSubmitted.current) {
      return;
    }
    hasSubmitted.current = true;

    changeEmployeeEmail({
      variables: { organizationId, token },
    });
  }, [changeEmployeeEmail, organizationId, token]);
  const { isLoggedIn, isLoading: isLoggedInLoading } = useAuth();

  useEffect(() => {
    if (data) {
      const redirectToRoute = isLoggedIn ? dashboardRoot : routes.login;
      if (data.changeEmployeeEmail.hasEmailChanged) {
        history.push(redirectToRoute.route.create({}), {
          alertMessage: 'change-email',
        });
      } else {
        history.push(redirectToRoute.route.create({}));
      }
    }
  }, [data, history, isLoggedIn]);
  if (loading || isLoggedInLoading) return <Loading />;
  if (error) return <ServerError error={error} />;
  return <></>;
};

export default ChangeEmail;
